import React, { useEffect } from "react";
import { useNavigate } from "react-router";
import { useGlobalStore } from "~/store";
import { logout } from "~/store/auth/actions";

import { useTranslation } from "react-i18next";
// Components

// Assets

const PwChangeComplete = () => {
	const navigate = useNavigate();

	const [,dispatch] = useGlobalStore();

	useEffect(() => {
		dispatch(logout());
	});

	const { t } = useTranslation();

	return (
		<>
			<div className="phrase-wrap">
				<h3>Change Password!</h3>
				<p>
                    {t("pages.auth.FindPwPage.Change.PwChangeComplete.passwordChange")}
					<br />
                    {t("pages.auth.FindPwPage.Change.PwChangeComplete.newPassword")}
				</p>
			</div>
			<div className="btn-wrap">
				<button onClick={() => navigate('/')} className="btn__solid" color="primary">
                    {t("pages.auth.FindPwPage.Change.PwChangeComplete.login")}
				</button>
			</div>
		</>
	);
};

export default PwChangeComplete;
